import { CtrlCollection } from '@yuigoto/ctrl';
import { ControlRenderer } from 'components/renderers/ControlRenderer';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import MaterialTable from 'material-table';
import React from 'react';
import { connect } from "react-redux";
import { UiActions } from 'state/actions/UiActions';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';
import { Utils } from 'utils/Utils';
import { tableIcons } from './TableIcons';
import { ComissionControl } from "controls/ComissionControl";

export class GlamboxComission extends React.Component {
  constructor(props) {
    super(props);

    this.props.isAdmin(
      this.props.person.person.username,
      (response) => {
        const isAdmin = response.result;
        if (!isAdmin) {
          props.history.push("/");
        }
      });

    this.state = {
      glamboxComissions: []
    }
  }

  componentDidMount() {
    this.getGlamboxComissions();
  }
 

  getGlamboxComissions = async () => {
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.Partner.getPaymentRegistry,
      {
        businessUnityId: 1
      },
      "GET",
      {
        'Authorization': this.props.token
      },
      null,
      (response) => {
        const {
          statusCode,
          result
        } = response;

        if (statusCode === 200) {
          this.setState({
            glamboxComissions: result.result
          });
        }
      }
    );

    this.props.loaderHide();
  }

  getHeaders = () => {
    let headers = [
      {
        title: 'From', field: 'dateFrom', hiddenByColumnsButton: true, editable: 'never', render: (rowData) => {
          return Utils.tempConvertDate(rowData.dateFrom)
        }
      },
      {
        title: 'To', field: 'dateTo', hiddenByColumnsButton: true, render: (rowData) => {
          return rowData.dateTo && Utils.tempConvertDate(rowData.dateTo)
        }
      },
      {
        title: 'Created', field: 'dateCreated', editable: 'never', hiddenByColumnsButton: true,
        render: (rowData) => {
          return rowData.dateCreated && Utils.tempConvertDate(rowData.dateCreated)
        }
      },
      {
        title: 'Created by', field: 'createdBy', editable: 'never', hiddenByColumnsButton: true
      },
      {
        title: 'Updated', field: 'dateUpdated', editable: 'never', hiddenByColumnsButton: true,
        render: (rowData) => {
          return rowData.dateUpdated && Utils.tempConvertDate(rowData.dateUpdated)
        }
      },
      { title: 'Updated by', field: 'updatedBy', editable: 'never', hiddenByColumnsButton: true },
      { title: 'Description', field: 'description', hiddenByColumnsButton: true },
      
      { title: 'PaymentMonth', field: 'paymentMonth',editable: 'never',  hiddenByColumnsButton: true },
      { title: 'PaymentSixMonth', field: 'paymentSixMonth', editable: 'never', hiddenByColumnsButton: true },
      { title: 'PaymentAnnual', field: 'paymentAnnual', editable: 'never', hiddenByColumnsButton: true },
      {
        title: 'InfluencerStatus', field: 'influencerStatusRestriction', hiddenByColumnsButton: true,
        editComponent: props => {
          const options = [null, 1, 2, 3, 4, 5];
          return (
            this.renderStatusOptions(props, options)
          )
        }
      }

    ]

    return headers;
  }

  renderStatusOptions = (props, options) => {
    return (
      <select onChange={(e) => {
        props.onChange(e.target.value)
      }}
        value={props.value}>

         <option disabled>Escolha uma opção</option> 
        {(() => {
          return options.map((value, key) => {
            return (
              <option value={value} key={key}>
                {value}
              </option>
            );
          });
        })()}
      </select>);
  }
  renderGlamboxComission = () => {
    const { glamboxComissions } = this.state;
    if (glamboxComissions.length < 1) return null;

    const editable = this.getEditable();
    return (
      <MaterialTable
        columns={this.getHeaders()}
        data={glamboxComissions}
        title="Comissões Glambox"
        editable={editable}
        options={{
          columnsButton: true,
          exportButton: true,
          exportAllData: true,
          actionsColumnIndex: -1
        }}
        icons={tableIcons}
      />
    );

  }

  getEditable = () => {
    let editable = {
      onRowUpdate: (newData, oldData) => {
        return new Promise((resolve, reject) => {
          const { glamboxComissions } = this.state;

          let dataUpdate = [...glamboxComissions];

          for (const n in dataUpdate) {
            if (dataUpdate[n].glampartnerPaymentId === newData.glampartnerPaymentId) {
              dataUpdate[n] = Object.assign({}, dataUpdate[n], newData);
            }
          }

          const payload = this.getUpdatePayload(newData, oldData);

          this.updateData(payload, () => {
            this.setState({
              glamboxComissions: dataUpdate
            });
            resolve();
          });
        });
      },
      onBulkUpdate: (changes) => {
        return new Promise((resolve, reject) => {
          this.updateBulk(changes, () => resolve());
        });

      }
    }
    return editable;
  }

  getUpdatePayload = (newData, oldData) => {   
    let dateTo = newData.dateTo;
    
    if(typeof dateTo === "number"){
      dateTo = new Date(dateTo);

      let newDateOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }
      dateTo = dateTo.toLocaleString("pt-BR", newDateOptions );
    }   
    
    let payload = {
      id: oldData.glampartnerPaymentId,
      reference: newData.reference,
      description: newData.description,
      paymentMonth: newData.paymentMonth,
      paymentSixMonth: newData.paymentSixMonth,
      paymentAnnual: newData.paymentAnnual,
      businessUnityId: 1,
      influencerStatusRestriction: newData.influencerStatusRestriction ? parseInt(newData.influencerStatusRestriction) : null,
      dateTo: dateTo,
      value: oldData.value
    }
    return payload;
  }

  updateData = async (payload, callback) => {
    await this.updateComission(payload);
    callback();
  }

  updateComission = async (payload) => {
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.GlampartnerPaymentRegistry.updatePaymentRegistry,
      Object.assign({}, payload),
      "PUT",
      {
        'Authorization': this.props.token
      },
      null,
      (response) => {
        const { statusCode, result } = response;
        if (statusCode === 200) {
          this.props.publishSuccessAlert("Registro atualizado");
        } else {
          this.props.publishErrorAlert(result.message);
        }
      }
    );

    this.props.loaderHide();
  }

  updateBulk = (changes, callback) => {
    for (let n in changes) {
      let newData = changes[n].newData;
      let oldData = changes[n].oldData;

      const payload = this.getdUpdatePayload(newData, oldData);
      this.updateData(payload, callback);
    }
  }

  render() {
    return (
      <>
        <div className={"mb-2"}>
          {this.renderGlamboxComission()}
        </div>
      </>
    );
  }

}

const mapStateToProps = (state) => ({
  store: state,
  person: state.person.data,
  partnerGeneral: state.partnerGeneral.data,
  token: state.token.data.Authorization

});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  }
});

GlamboxComission = connect(
  mapStateToProps,
  mapDispatchToProps
)(GlamboxComission);
